module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/about-lindy-300.ea82f763b3288241.jpeg"+" 300w",
        images: [{path: "https://static.sniffspot.com/packs/img/about-lindy-300.ea82f763b3288241.jpeg",width: 300,height: 225}],
        src: "https://static.sniffspot.com/packs/img/about-lindy-300.ea82f763b3288241.jpeg",
        toString: function(){return "https://static.sniffspot.com/packs/img/about-lindy-300.ea82f763b3288241.jpeg"},
        
        width: 300,
        height: 225
      }